import type { QueryKey } from '@tanstack/react-query';

import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';
import { nuc } from '../../../utils';
import type { MinimalBranch } from '../../../shared/branches/types';

function fetchBranches(projectLocator: string) {
  return get<MinimalBranch[]>(`/api/projects/${nuc(projectLocator)}/branches`, false);
}

const getQueryKey = (locator: string): QueryKey => ['projects', locator, 'branches'];

/**
 * Query for the branches of a project.
 *
 * @param {string} projectLocator - The projectLocator of the project whose branches to fetch. No need to call nuc before passing it in here.
 * @param {boolean} shouldFetch - Will not fetch if false.
 */
export default function useProjectBranches(projectLocator: string, shouldFetch = true) {
  return useQuery({
    queryKey: getQueryKey(projectLocator),
    queryFn: () => fetchBranches(projectLocator),
    enabled: shouldFetch,
  });
}
